import CustomDateField from "components/CustomDateField";
import StatusField from "components/StatusField";
import PostCashReceiptButton from "pages/cashReceipts/Component/PostCashReceiptButton";
import {
  ResourceContextProvider,
  List,
  Datagrid,
  TextField,
  FunctionField,
  Filter,
  SearchInput,
  SelectInput,
} from "react-admin";
import { paymentStatusFilterList } from "../conts";
import CancelPaymentButton from "./CancelPaymentButton";
import PaymentListPanel from "./PaymentListPanel";

interface IPaymentHistoryTable {
  userId?: number;
  fromDate?: string;
  toDate?: string;
}

const PaymentHistoryTable = ({
  userId,
  fromDate,
  toDate,
}: IPaymentHistoryTable) => {
  const PaymentHistoryFilter = (props: any) => (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
      <SelectInput source="Status" choices={paymentStatusFilterList} alwaysOn />
    </Filter>
  );

  return (
    <ResourceContextProvider value="payments">
      <List
        basePath="/payments"
        exporter={false}
        hasCreate={false}
        actions={null}
        filters={<PaymentHistoryFilter />}
        filterDefaultValues={{
          UserId: userId,
          FromDate: fromDate,
          ToDate: toDate,
        }}
        sort={{ field: "createdAt", order: "DESC" }}
        bulkActionButtons={false}
        title=" "
      >
        <Datagrid expand={<PaymentListPanel />}>
          <TextField source="id" />
          <TextField source="paymentPlatform" emptyText="-" />
          <TextField source="description" />
          <CustomDateField source="createdAt" />
          <StatusField source="status" />
          {localStorage.getItem("roles") === "superadmin" && (
            <FunctionField
              label="Action"
              render={(record: any) => {
                return (
                  <>
                    {record.status === "new" && (
                      <CancelPaymentButton id={record.id} />
                    )}
                    {record.status === "new" &&
                      record.paymentPlatform === "manual_bank_transfer" && (
                        <PostCashReceiptButton
                          id={record.id}
                          number={record.description}
                        />
                      )}
                  </>
                );
              }}
            />
          )}
        </Datagrid>
      </List>
    </ResourceContextProvider>
  );
};

export default PaymentHistoryTable;
